export default __webpack_public_path__ + "static/char-t-21-en-cef3840bff7dd8a8e2ec3886e3641286.webp";